import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DashboardContainer = styled('div')({
  width: 'calc(100% - 210px)',
  height: '100vh'
});

export const TitleTypography = styled(Typography)<TypographyProps>({
  marginTop: '47px',
  marginLeft: '45px',
  fontFamily: 'Open Sans',
  fontSize: '34px',
  color: 'black'
});
